/**
 * Lista canônica de rotas da SPA — fonte única, compartilhada entre o router
 * React (`AppRouter.tsx`, que a usa para gerar os redirects de URL antiga
 * `/<rota>.html`) e o script de pós-build (`scripts/emit-routes.mjs`, que
 * materializa cada rota como arquivo físico em `dist/`).
 *
 * Por que `.mjs` puro (sem TypeScript/JSX)? `emit-routes.mjs` roda com
 * `node` puro, depois do `vite build`, sem transpiler disponível — então a
 * fonte de verdade não pode ser um `.ts`/`.tsx`. O lado TypeScript
 * (`AppRouter.tsx` e afins) importa este mesmo arquivo; o typecheck é
 * satisfeito por `route-paths.d.mts`, ao lado, que só declara os tipos
 * (Node ignora `.d.mts` em tempo de execução; o TypeScript/Vite ignora o
 * corpo do `.mjs` e usa só a declaração para checar tipos, mas o bundle
 * final referencia o valor real do `.mjs`).
 *
 * Alterou uma rota aqui? Lembre de: (1) criar/apontar o placeholder em
 * `src/pages/<Nome>/index.tsx`, (2) registrar o `<Route>` correspondente em
 * `AppRouter.tsx`, e (3), se for item de menu, atualizar `nav-config.ts`.
 */
export const APP_ROUTES = [
  // PUBLICA: app do participante. Fica fora do RequireAuth no AppRouter e o
  // backend libera /ui/app em is_public() — quem usa nao tem conta.
  "/app",
  "/login",
  "/visao-geral",
  "/evento",
  "/agenda",
  "/cerebro-ia",
  "/atendimento",
  "/participantes",
  "/interacao",
  "/expositores",
  "/certificados",
  "/relatorios",
  "/usuarios",
  "/admin",
  "/whatsapp",
  "/kiosk",
  "/mediator",
  "/participant",
  "/exhibitor",
  "/poc-whatsapp",
];
